export const eventTypeEnum = {
  STATUS_CHANGED: "STATUS_CHANGED"
};
